import React, { useState, useEffect } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { Link } from 'gatsby';
import { PoweredBy } from './styles';
import Highlighter from 'react-highlight-words';
import '@fortawesome/fontawesome-free/js/all';

export default function Search({ indices }) {
  const [query, setQuery] = useState(``);
  const [hits, setHits] = useState([]);
  const [numberOfHits, setNumberOfHits] = useState(false);
  const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  );
  const index = searchClient.initIndex(indices[0].name);
  useEffect(() => {
    index
      .search({ query: query, highlightPreTag: '"', highlightPostTag: '"' })
      .then(result => {
        setHits(result.hits);
        setNumberOfHits(result.nbHits);
      });
  }, [query]);

  const SearchBox = () => (
      <div className="control has-icons-left">
        <span className="icon is-small is-left">
          <i className="fas fa-search" aria-hidden="true"></i>
        </span>
        <input
          autoFocus
          className="input"
          type="text"
          placeholder="Search"
          onChange={e => {
            setQuery(e.target.value);
          }}
          value={query}
        />
      </div>
  );

  if (!query || !query.length) {
    return <SearchBox />;
  }
  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="panel" style={{ background: 'white' }}>
          <p className="panel-heading">Searching</p>
          <div className="panel-block">
            <SearchBox />
          </div>
          <header>Found {numberOfHits} results!</header>
          <table className="table">
            <tbody>
              {hits.map(hit => {
                return (
                  <tr key={hit.objectID}>
                    <td className="is-size-6">
                      <Link to={hit.slug}>
                        <Highlighter
                          highlightClassName="search-highlight"
                          searchWords={[query]}
                          autoEscape={true}
                          textToHighlight={hit.title}
                        />
                      </Link>
                    </td>
                    <td>
                      <Highlighter
                        highlightClassName="search-highlight"
                        searchWords={[query]}
                        autoEscape={true}
                        textToHighlight={hit._snippetResult.excerpt.value}
                      />{' '}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <PoweredBy />
        </div>
      </div>
      <button
        onClick={() => {
          setQuery('');
        }}
        className="modal-close is-large"
        aria-label="close"
      />
    </div>
  );
}
